module.exports = __webpack_public_path__ + "img/nature-3.ffd55f37.jpg";